import { render, staticRenderFns } from "./TheArqueoCajaClinica.vue?vue&type=template&id=23cb1462&scoped=true&"
import script from "./TheArqueoCajaClinica.vue?vue&type=script&lang=js&"
export * from "./TheArqueoCajaClinica.vue?vue&type=script&lang=js&"
import style0 from "./TheArqueoCajaClinica.vue?vue&type=style&index=0&id=23cb1462&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cb1462",
  null
  
)

export default component.exports